import { v4 as uuidv4 } from "uuid";

const STORAGE_PREFIX = "idempotency_key_";

export function getOrCreateKey(group: string): string {
  const storageKey = `${STORAGE_PREFIX}${group}`;

  try {
    const existingKey = localStorage.getItem(storageKey);
    if (existingKey) {
      return existingKey;
    }

    const newKey = uuidv4();
    localStorage.setItem(storageKey, newKey);
    return newKey;
  } catch (error) {
    console.warn("localStorage not available, using session-only key:", error);
    return uuidv4();
  }
}

export function clearKey(group: string): void {
  const storageKey = `${STORAGE_PREFIX}${group}`;

  try {
    localStorage.removeItem(storageKey);
  } catch (error) {
    console.warn("Failed to clear idempotency key:", error);
  }
}

export function clearAllKeys(): void {
  try {
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      if (key.startsWith(STORAGE_PREFIX)) {
        localStorage.removeItem(key);
      }
    });
  } catch (error) {
    console.warn("Failed to clear all idempotency keys:", error);
  }
}
